export default __webpack_public_path__ + "static/media/empt.4cedc201.svg";